<template>
  <!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
  <a-layout-header v-if="!headerBarFixed">
    <div class="header_zj">
      <img class="logo"
           src="../../assets/logo1.svg">
      <div class="title">{{sys_title}}</div>
      <div style="flex: 0 0 auto">
        <a-space v-if="isExpertOrg">
          <div class="consult_tel">咨询电话：{{ consult_telePhone }}</div>
          <div class="logout_title"
               @click="handleLogout">【退出登录】</div>
        </a-space>
        <user-menu v-else></user-menu>
      </div>
    </div>
    <div class="header_zj_nav"
         v-if="isExpertOrg">
      <ul>
        <li :class='selectedItemVal === 0 ? "active":""'
            @click="workPlaceJump('/dashboard/workplace')">
          <div>
            <a-icon type="home"
                    theme="filled" />
            <p>首页</p>
          </div>
        </li>
        <li :class='selectedItemVal === 1 ? "active":""'
            @click="workPlaceJump('/loginExpert/selectApplyIndex')">
          <div>
            <a-icon type="sound"
                    theme="filled" />
            <p>历史采购活动通知</p>
          </div>
        </li>

        <li :class='selectedItemVal === 2 ? "active":""'
            @click="workPlaceJump('/expertInfo/expertLoginView')">
          <div>
            <a-icon type="idcard"
                    theme="filled" />
            <p>我的资料</p>
          </div>
        </li>

        <li :class='selectedItemVal === 4 ? "active":""'
            @click="workPlaceJump('/expertInfo/expertLeaveRecord')">
          <div>
            <i class="iconfont">&#xe614;</i>
            <p>休假设置</p>
          </div>
        </li>
        <li :class='selectedItemVal === 3 ? "active":""'
            @click="workPlaceJump('/expertInfo/expertLoginStockOutAdd')">
          <div>
            <i class="iconfont">&#xe610;</i>
            <p>出库申请</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="header"
         v-else>
      <s-menu class="sideMenu"
              :collapsed="collapsed"
              :menu="menus"
              theme="light"
              mode="horizontal"
              @select="onSelect"></s-menu>
    </div>

  </a-layout-header>
</template>

<script>
import UserMenu from '@/components/tools/UserMenu.vue'
import SMenu from '../Menu/'
import { mixin } from '@/utils/mixin'
import { mapActions } from 'vuex'
import { handleScrollHeader, IsExpertOrg } from '@/utils/util'
import { SYS_TITLE, CONSULT_TELE_PHONE } from '@/store/mutation-types'
import { GetExpertByUserId } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'GlobalHeader',
  components: {
    UserMenu,
    SMenu,
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    }
  },
  data () {
    return {
      consult_telePhone: this.$ls.get(CONSULT_TELE_PHONE),
      headerBarFixed: false,
      user: this.$ls.get('user'),
      selectedItemVal: 0,
      expertOutOrIn: true,
      sys_title: this.$ls.get(SYS_TITLE),
    }
  },
  mounted () {
    const _this = this
    handleScrollHeader(direction => {
      _this.handleScroll(direction)
    })
    if (this.$route.path.indexOf('/dashboard/workplace') !== -1) {
      this.selectedItemVal = 0
    } else if (this.$route.path.indexOf('/loginExpert/selectApplyIndex') !== -1) {
      this.selectedItemVal = 1
    } else if (('/expertInfo/expertLoginView,/expertInfo/expertLoginEdit').includes(this.$route.path)) {
      this.selectedItemVal = 2
    } else if (('/expertInfo/expertLoginAdd,/expertInfo/expertLoginStockOutAdd').includes(this.$route.path)) {
      this.selectedItemVal = 3
    } else if (this.$route.path.indexOf('/expertInfo/expertLeaveRecord') !== -1) {
      this.selectedItemVal = 4
    }
  },
  created () {
  },
  computed: {
    isExpertOrg () {
      return IsExpertOrg(this)
    }
  },
  methods: {
    ...mapActions(['Logout']),
    handleScroll (direction) {
      if (this.autoHideHeader) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (direction === 'up') {
          this.headerBarFixed = false
        } else {
          scrollTop > 100 && (this.headerBarFixed = true)
        }
      } else {
        this.headerBarFixed = false
      }
    },
    toggle () {
      this.$emit('toggle')
    },
    workPlaceJump (target) {
      this.$router.push({ path: target })
    },
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    },
    //获取是否是出库还是入库
    async getExpertOutOrIn () {
      this.expertOutOrIn = !!(await GetExpertByUserId()).result
    },
    handleLogout () {
      const that = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
            window.location =  process.env.VUE_APP_WEB_SERVER+'/#/expertLogin'
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header_zj_nav {
  ul {
    margin: 20px 0 0;
    list-style: none;
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 12px;
    li {
      padding: 0 8px;
      flex: 1;
      div {
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #646464;
        line-height: 1;
        height: 66px;
        border-radius: 8px;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 12px;
        }
        p {
          margin: 0;
          font-size: 20px;
        }
      }
      &.active {
        div {
          background: #1e63d4;
          color: #fff;
        }
      }
    }
  }
}

.header_zj {
  background-image: url('../../assets/header_bg.png');
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  align-items: center;
  height: 93px;
  padding: 0 16px;
  .consult_tel {
    font-size: 20px;
    color: #fff;
    font-weight: 500;
  }
  .logout_title {
    cursor: pointer;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
    margin-left: 80px;
  }
  .logo {
    flex: 0 0 auto;
  }
  .title {
    width: 100%;
    border-left: 1px solid #fff;
    margin-left: 20px;
    padding-left: 20px;
    line-height: 30px;
    font-size: 26px;
    color: #fff;
    font-weight: 500;
  }
}
</style>
